<template>
  <div id="app">
    <router-view name="blank"></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
#app {
  background-color: #222d32;
}

.sl {
  color: #909399;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  -o-white-space: nowrap;
  -webkit-white-space: nowrap;
  -moz-white-space: nowrap;
  -ms-white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
}

.station {
  max-height: 400px;
  overflow-y: auto;
}

.suo {
  text-align: center;
  border: 1px solid #e9e9eb;
  border-radius: 30px;
  font-size: 12px;
  display: inline-block;
  padding: 0px 10px;
}
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
    -moz-appearance: textfield;
}
</style>
